import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { Booth } from '../../../../../../interfaces/interfaces';

const AddRoomButton = ({
  booth,
  type,
  limit,
  onAdd,
  sectionValue,
}: {
  booth: Booth;
  type: 'meeting' | 'conference';
  limit: number;
  onAdd: () => Promise<void>;
  sectionValue: number;
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    await onAdd();
    setLoading(false);
  };

  return booth.hasUnlimitedRooms || sectionValue < limit ? (
    <div className="w-full my-4 grid place-items-center">
      {loading ? (
        <CircularProgress />
      ) : (
        <div
          onClick={() => onClick()}
          className="opacity-50 rounded-full bg-slate-700 w-10 h-10 flex justify-center items-center text-white hover:opacity-75 cursor-pointer">
          <FontAwesomeIcon className="trash-icon" icon={faPlus} />
        </div>
      )}
      {!booth.hasUnlimitedRooms && (
        <div className="mt-2">
          <Typography variant="caption" color="textSecondary" gutterBottom>
            {t(`booth:${type}-rooms-limit`, { limit })}
          </Typography>
        </div>
      )}
    </div>
  ) : (
    <div className="text-center">
      <Typography variant="caption" color="textSecondary" gutterBottom>
        {t(`booth:${type}-rooms-limit-exceeded`)}
      </Typography>
    </div>
  );
};
export default AddRoomButton;
